
export default[
  {
    path: '/about',
    name: 'about',
    meta:{
      title:'关于我们'
    },
    component: () => import('../views/About/AboutUs.vue')
  },
  {
    path: '/ourservices',
    name: 'ourServices',
    meta:{
      title:'我们的服务'
    },
    component: () => import('../views/About/OurServices.vue')
  },
]



// WEBPACK FOOTER //
// ./src/router/about.js